import { render, staticRenderFns } from "./PaidConsultationForm.vue?vue&type=template&id=29e7b67b&lang=pug"
import script from "./PaidConsultationForm.vue?vue&type=script&lang=ts"
export * from "./PaidConsultationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports